import * as React from "react";
import {connect} from "react-redux";
import {FLIP_MATCH_STATE_TYPE} from "../FlipMatch/constants";

const FlipMatchState = (WrappedComponent) => {

    // eslint-disable-next-line react/prefer-stateless-function
    class FlipMatchStateInner extends React.Component {
        render() {
            const { props } = this;
            return <WrappedComponent {...props}/>;
        }
    };

    FlipMatchStateInner.propTypes = {
        flip: FLIP_MATCH_STATE_TYPE
    };

    FlipMatchStateInner.defaultProps = {
        flip: {}
    };

    const mapStateToProps = (state) => {
        return {flip: {...state.flip}};
    };

    return connect(
        mapStateToProps,
        null
    )(FlipMatchStateInner);
}

export default FlipMatchState;